import { Component, Input, NgZone, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';
import moment from 'moment';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { mustMatch } from '../utils/app-validators';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.css'],
})
export class CreateEventComponent implements OnInit {
  @Input() status: string = 'create';
  @Input() dataObj: any;

  form: FormGroup;
  customCategory: FormArray;
  submitted = false;
  errorMessage;
  model: NgbDateStruct;
  modelSecond: NgbDateStruct;
  datesArray = [];
  hourArray = [];
  gallaryArr = [];
  loading = false;
  selectedItem;
  eventImage = '';
  closeResult = '';
  showImage = false;
  showDays = false;
  showhours = false;
  notifyAttendersValue = false;
  notifyvisitorsValue = false;
  baseUrl = environment.basePath;
  startTime = { hour: 0, minute: 0 };
  endTime = { hour: 0, minute: 0 };
  allAddress = '';
  eventID: any;
  constructor(
    private authService: AuthenticationService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    private zone: NgZone
  ) {}
  ngOnInit(): void {
    this.getGallary();
    // this.AddressChange(this.dataObj.address)
    this.errorMessage = environment?.errorMessage;
    this.form = this.fb.group({
      eventName: ['', Validators.required],
      description: [''],
      validFrom: ['', Validators.required],
      validTill: ['', Validators.required],
      startTime: ['00'],
      endTime: ['00'],
      photo: [''],
      address: ['', Validators.required],
      address2: [''],
      notifyVisitors: [false],
      notifyAttenders: [false],
      notifyVisitorsBefore: [''],
      notifyAttenderBefore: [''],
      accessibility: ['', Validators.required],
      role: 'Merchant',
    });

    if (this.dataObj && this.dataObj._id) {
      let obj = {
        streetAddress: '',
        city: '',
        state: '',
        googleAddress: '',
        postalCode: '',
        country: '',
        suite_no: '',
        landMark: ''
      };
      // patch this.data value in this.form like
      this.form.patchValue({
        eventName: this.dataObj.eventName || '',
        description: this.dataObj.description || '',
        validFrom: this.dataObj.validFrom || '',
        validTill: this.dataObj.validTill || '',
        startTime: this.dataObj.startTime || '00',
        endTime: this.dataObj.endTime || '00',
        photo: this.dataObj.photo || '',
        address: this.dataObj.address.streetAddress || '',
        address2:this.dataObj.address2 || '',
        notifyVisitors: this.dataObj.notifyVisitors || false,
        notifyAttenders: this.dataObj.notifyAttenders || false,
        notifyVisitorsBefore: this.dataObj.notifyVisitorsBefore || '',
        notifyAttenderBefore: this.dataObj.notifyAttenderBefore || '',
        accessibility: this.dataObj.accessibility || '',
        role: this.dataObj.role || 'Merchant',
      });
    }
  }

  get f() {
    return this.form.controls;
  }

  editFormData() {
    this.form.controls['description'].setValue(this.dataObj.description);
  }

  open(content) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  // onSubmit() {
  //   console.log("tHis.form.value>>>>>>>>>>>>..", this.form.value);
  //   this.submitted = true;
  //   if (this.form.invalid) {
  //     this.authService.scrollToError();
  //     return;
  //   }
  //   if(this.model >= this.modelSecond) {
  //     Swal.fire(
  //       '',
  //       'Event end date should be greater than the event start date.',
  //       'error'
  //     );
  //     return false
  //   }

    // if (this.status === 'update') {
    //   // Call the update API
    //   this.authService
    //     .updateMerchantEvent(this.form.value, this.dataObj._id)
    //     .subscribe(
    //       (res: any) => {
    //         this.messageAlert(res.message, 'success');
    //         this.router.navigate(['/my-events']);
    //       },
    //       (error) => {
    //         this.messageAlert(error.error.message, 'error');
    //       }
    //     );
    // } else {
    //   // Call the create API
    //   this.authService.createMerchantEvent(this.form.value).subscribe(
    //     (res: any) => {
    //       this.messageAlert(res.message, 'success');
    //       this.router.navigate(['/my-events']);
    //     },
    //     (error) => {
    //       this.messageAlert(error.error.message, 'error');
    //     }
    //   );
    // }

    // //call update api
    // // select with Id
  // }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    // Extract date from the form and ignore time
    let validFrom = new Date(this.form.get('validFrom').value);
    let validTill = new Date(this.form.get('validTill').value);

    // Reset time to midnight (00:00)
    validFrom.setHours(0, 0, 0, 0);
    validTill.setHours(0, 0, 0, 0);

    // Compare dates
    if (validFrom > validTill) {
      Swal.fire('', 'Event end date should be greater than or equal to the event start date.', 'error');
      return false;
    }
    if (this.status === 'update') {
      // Call the update API
      this.authService
        .updateMerchantEvent(this.form.value, this.dataObj._id)
        .subscribe(
          (res: any) => {
            this.messageAlert(res.message, 'success');
            this.router.navigate(['/my-events']);
          },
          (error) => {
            this.messageAlert(error.error.message, 'error');
          }
        );
    } else {
      // Call the create API
      this.authService.createMerchantEvent(this.form.value).subscribe(
        (res: any) => {
          this.messageAlert(res.message, 'success');
          this.router.navigate(['/my-events']);
        },
        (error) => {
          this.messageAlert(error.error.message, 'error');
        }
      );
    }

    //call update api
    // select with Id

  }

  selectImage(props, index) {
    this.selectedItem = index;
    this.eventImage = this.checkImage(props.url);
  }
  containsHttpOrHttps(url) {
    const pattern = /^(http:\/\/|https:\/\/)/i;
    return pattern.test(url);
  }
checkImage(image: any) {
  const defaultImage = 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg';

  if (!image) return defaultImage;

  // if it's already a complete URL (has http/https), return as is
  if (this.containsHttpOrHttps(image)) {
    return image;
  }

  let imgUrl = image.trim();

  // ensure proper path formatting
  if (imgUrl.startsWith('/uploads/')) {
    return `${environment.basePath.replace(/\/$/, '')}${imgUrl}`;
  } else if (imgUrl.startsWith('uploads/')) {
    return `${environment.basePath.replace(/\/$/, '')}/${imgUrl}`;
  } else if (imgUrl.startsWith('/')) {
    return `${environment.basePath.replace(/\/$/, '')}/uploads${imgUrl}`;
  } else {
    return `${environment.basePath.replace(/\/$/, '')}/uploads/${imgUrl}`;
  }
}
  renderImage(image: any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      return `${this.baseUrl}uploads${imgUrl}`;
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg';
    }
  }
  getGallary() {
    this.authService.gallery(0, 50).subscribe(
      (res: any) => {
        this.loading = true;
        this.gallaryArr = res.items;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  check(event: any, type: any) {
    if (event.target.checked && (type == 'visitors' || type == 'attendees')) {
      this.findDiff(type);
    } else {
      this.showhours = false;
      this.showDays = false;
    }
  }

  addimageForm() {
    this.showImage = true;
    this.form.get('photo').setValue(this.eventImage);
  }


  findDiff(type: string) {
    let today = new Date();

    if (this.model && this.modelSecond) {
      this.hourArray = [];

      // Combine start date and start time
      let startDateTime = moment(this.model).set({
        hour: this.form.get('startTime').value.hour,
        minute: this.form.get('startTime').value.minute
      });

      // Combine end date and end time
      let endDateTime = moment(this.modelSecond).set({
        hour: this.form.get('endTime').value.hour,
        minute: this.form.get('endTime').value.minute
      });

      // Calculate difference in seconds
      let diffSeconds = endDateTime.diff(startDateTime, 'seconds');
      let startEventBeforeDays = startDateTime.diff(moment(today), 'days');
      let startEventBeforehrs = startDateTime.diff(moment(today), 'hours');

      // Allow same-day events or small differences like seconds/minutes/hours
      if (diffSeconds >= 0) {
        if (type == 'attendees') {
          this.notifyAttendersValue = true;
          this.hourArray = [];
          this.showhours = true;
          this.form.get('notifyAttenders').setValue(true);

          if (startEventBeforehrs > 0) {
            for (let i = 0; i < startEventBeforehrs; i++) {
              this.hourArray.push(i + 1);
            }
          }
        } else if (type == 'visitors') {
          this.datesArray = [];
          this.showDays = true;
          this.form.get('notifyVisitors').setValue(true);

          if (startEventBeforeDays === 0) {
            this.datesArray.push(2);
          } else if (startEventBeforeDays !== 0) {
            for (let i = 0; i < startEventBeforeDays; i++) {
              this.datesArray.push(i + 1);
            }
          }
        }
      } else {
        console.log("End date must be greater than the start date.");
        this.authService.successMessage('End date should be greater than the start date', 'error');
      }
    }
  }


  AddressChange(address: any) {
    console.log(address)
    let obj = {
      streetAddress: '',
      city: '',
      state: '',
      googleAddress: '',
      postalCode: '',
      country: '',
      suite_no: '',
      landMark: '',
      location: { type: 'Point', coordinates: [] },
    };
    this.zone.run(() => {
      this.createArray(address, obj);
    });
  }

  createArray(address:any, addressobj:any) :any{
    let latitude = address.geometry?.location.lat();
    let longitude = address.geometry?.location.lng();

    // this.form.get('addressName').setValue(address.formatted_address),
    addressobj['streetAddress'] = address.formatted_address;
    addressobj['googleAddress'] = address.name ? address.name : '';
    addressobj['location'] = {
      type: 'Point',
      coordinates: [latitude, longitude],
    };

    let address_components = address?.address_components;
    for (let i = 0; i < address_components.length; i++) {
      if (address_components[i].types[0] == 'administrative_area_level_2') {
        addressobj['city'] = address_components[i].long_name || '';
      } else if (
        address_components[i].types[0] == 'administrative_area_level_1'
      ) {
        addressobj['state'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'country') {
        addressobj['country'] = address_components[i].long_name || '';
      } else if (address_components[i].types[0] == 'postal_code') {
        addressobj['postalCode'] = address_components[i].long_name || '';
      }
    }
    // this.allAddress = `${addressobj.streetAddress}`
    this.form.get('address').setValue(addressobj);
    // this.form.get('address').setValue(addressobj['streetAddress']);

  }
  messageAlert(message, type) {
    this.authService.successMessage(message, type);
  }
}
